import {
  MODIFY_HELP_SUMMARY, MODIFY_HELP_DESCRIPTION, MODIFY_HELP_ATTACHMENTS, MODIFY_HELP_CLASSIFICATION, MODIFY_HELP_HARDWARE,
  MODIFY_HELP_SOFTWARE, MODIFY_HELP_VEHICLES, MODIFY_HELP_PARTIES, MODIFY_HELP_RECIPIENTS, MODIFY_HELP_TRANSLATIONS, MODIFY_HELP,
  MODIFY_HELP_AREA, MODIFY_HELP_FEEDBACK, MODIFY_HELP_SUMMARY_FEEDBACK, MODIFY_HELP_SUMMARY_PLANT_FEEDBACK,
} from '../types';

export const setHelp = (help) => ({
  type: MODIFY_HELP,
  payload: help,
});

export const setHelpSummary = (summary) => ({
  type: MODIFY_HELP_SUMMARY,
  payload: summary,
});

export const setHelpDescription = (description) => ({
  type: MODIFY_HELP_DESCRIPTION,
  payload: description,
});

export const setHelpFeedback = (feedback) => ({
  type: MODIFY_HELP_FEEDBACK,
  payload: feedback,
});

export const setHelpAttachments = (attachments) => ({
  type: MODIFY_HELP_ATTACHMENTS,
  payload: attachments,
});

export const setHelpClassification = (classification) => ({
  type: MODIFY_HELP_CLASSIFICATION,
  payload: classification,
});

export const setHelpHardware = (hardware) => ({
  type: MODIFY_HELP_HARDWARE,
  payload: hardware,
});

export const setHelpSoftware = (software) => ({
  type: MODIFY_HELP_SOFTWARE,
  payload: software,
});

export const setHelpVehicles = (vehicles) => ({
  type: MODIFY_HELP_VEHICLES,
  payload: vehicles,
});

export const setHelpInvolvedParties = (involvedParties) => ({
  type: MODIFY_HELP_PARTIES,
  payload: involvedParties,
});

export const setHelpRecipients = (recipients) => ({
  type: MODIFY_HELP_RECIPIENTS,
  payload: recipients,
});

export const setHelpTranslations = (translations) => ({
  type: MODIFY_HELP_TRANSLATIONS,
  payload: translations,
});

export const setHelpSummaryFeedback = (summaryFeedback) => ({
  type: MODIFY_HELP_SUMMARY_FEEDBACK,
  payload: summaryFeedback,
});

export const setHelpSummaryPlantFeedback = (summaryFeedback) => ({
  type: MODIFY_HELP_SUMMARY_PLANT_FEEDBACK,
  payload: summaryFeedback,
});

export const setAreaHelp = (area) => ({
  type: MODIFY_HELP_AREA,
  payload: area,
});
